import React, {useEffect} from "react";
import {Controller, useForm} from "react-hook-form";
import Input from "../../../components/wrapperComponents/Input";
import {string2Bool} from "@commons/utils/util";
import {ElementoRMLXTabellaFormData, ElementoRMLXTabellaRecord} from "@commons/mapping/ElementoRMLXTabellaRecord";
import ComboBox from "../../../components/comboBox/ComboBox";
import {useGetElementiFlatQuery} from "@commons/features/elementiRML/ElementiRML.api";
import FormButtons from "../../../components/FormButtons";
import CheckboxEx from "../../../components/wrapperComponents/CheckboxEx";
import {ElementoRMLRecord} from "@commons/mapping/ElementoRMLRecord";

interface ElementoRMLEditorProps {
    defaultValues: ElementoRMLXTabellaFormData,
    resource: ElementoRMLXTabellaRecord;
    onSubmit: (formData: ElementoRMLXTabellaFormData) => void,
    onCancel: () => void;
}

const AziendaTabelleElementiRMLEditor: React.FC<ElementoRMLEditorProps> = ({defaultValues, resource, onSubmit, onCancel}) => {

    const codElemento = resource ? resource.codElemento : defaultValues.codElemento;
    const elementoRML: ElementoRMLRecord | null = codElemento ? ElementoRMLRecord.factory({codElemento, descrizione: null}) : null;
    const currentValues: ElementoRMLXTabellaFormData = {
        ...defaultValues, ...resource,
        ...{
            //sortOrder: resource ? resource.sortOrder : defaultValues.sortOrder,
            elementoRML,
        }
    };

    // https://stackoverflow.com/questions/62242657/how-to-change-react-hook-form-defaultvalue-with-useeffect
    const {register, control, watch, getValues, setValue, handleSubmit, reset, formState: {errors}} = useForm<ElementoRMLXTabellaFormData>();
    useEffect(() => {
        reset(currentValues)
    }, [resource]);

    function onHandleSubmit(newValues: ElementoRMLXTabellaFormData) {
        onSubmit({
            ...newValues,
            elementoDiscrezionale: string2Bool(newValues.elementoDiscrezionale),
            codElemento: newValues.elementoRML!.codElemento,
            elementoRML: undefined,
        })
    }

    const ComboBoxElementoRML = () => {
        const {data, isLoading} = useGetElementiFlatQuery({view: "Minimal"});
        return <Controller name="elementoRML"
                           control={control}
                           defaultValue={currentValues.elementoRML}
                           rules={{required: true}}
                           render={({field: {value, onChange}, fieldState}) => {
                               return (
                                   <ComboBox<ElementoRMLRecord> label={'Elemento RML'} value={value!} onChange={(v) => {
                                       onChange(v)
                                   }} fieldState={fieldState}
                                                                data={data}
                                                                isLoading={isLoading}

                                                                searchablePropsName={['codElemento', 'descrizione']}
                                                                isSameFn={(a, z) => (a && z) ? a.codElemento === z.codElemento : false}
                                                                keyValueFn={(v) => v.codElemento!}
                                                                displayValueFn={(v) => data && v ? v.descrizione! + ' [#' + v.codElemento + ']' : ''}
                                   />
                               )
                           }}
        />
    }

    //const currentElementoRML=getValues('elementoRML'); // NO
    const currentElementoRML = watch('elementoRML'); // SI
    //console.log('currentElementoRML',currentElementoRML);
    return <>

        <form className="space-y-8 divide-y divide-gray-200" onSubmit={handleSubmit(onHandleSubmit)}>
            <div>
                <div className="pt-8">
                    <div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                        <div className="sm:col-span-3">
                            <ComboBoxElementoRML/>
                        </div>

                        <div className="sm:col-span-3">
                            <label htmlFor="last-name" className="block text-sm font-medium">
                                Posizione
                            </label>
                            <div className="mt-1">
                                <Input
                                    type="text"
                                    name="sortOrder"
                                    register={register}
                                    //validation={Validation.required}
                                    errors={errors}
                                    readOnly={true}
                                />
                            </div>
                        </div>

                    </div>
                </div>

                <div className="pt-6 sm:pt-5">
                    <div role="group" aria-labelledby="label-notifications">
                        <div className="sm:grid sm:grid-cols-3 sm:items-baseline sm:gap-4">
                            <CheckboxEx name="elementoDiscrezionale"
                                        control={control}
                                        label="Elemento discrezionale"
                                        disabled={true}/>
                            {/*<div>
                                <div
                                    className="text-base font-medium sm:text-sm"
                                    id="label-notifications">
                                    Tipologia
                                </div>
                            </div>

                            <div className="sm:col-span-2">
                                <div className="max-w-lg">
                                    <div className="mt-4 space-y-4">
                                        <div className="flex items-center">
                                            <input
                                                id="comeTabellaRML"
                                                {...register("elementoDiscrezionale", Validation.required)}
                                                type="radio"
                                                value="null"
                                                className="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-500"
                                            />
                                            <label htmlFor="comeTabellaRML" className="ml-3 block text-sm font-medium">
                                                Default {currentElementoRML && currentElementoRML.elementoDiscrezionale ? '(discrezionale)' : '(contrattuale)'}
                                            </label>
                                        </div>
                                        <div className="flex items-center">
                                            <input
                                                id="tipologiaCCNL"
                                                {...register("elementoDiscrezionale", Validation.required)}
                                                type="radio"
                                                value="false"
                                                className="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-500"
                                            />
                                            <label htmlFor="tipologiaCCNL" className="ml-3 block text-sm font-medium">
                                                Elemento contrattuale
                                            </label>
                                        </div>
                                        <div className="flex items-center">
                                            <input
                                                id="tipologiaDiscrezionale"
                                                {...register("elementoDiscrezionale", Validation.required)}
                                                type="radio"
                                                value="true"
                                                className="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-500"
                                            />
                                            <label htmlFor="tipologiaDiscrezionale" className="ml-3 block text-sm font-medium text-gray-700">
                                                Elemento discrezionale
                                            </label>
                                        </div>
                                    </div>
                                    <ErrorMessage errors={errors} name="elementoDiscrezionale" render={Validation.render}/>
                                </div>
                            </div>*/}

                        </div>
                    </div>
                </div>
            </div>

            <FormButtons onCancel={onCancel} resource={resource}/>

        </form>

    </>;
}
export default AziendaTabelleElementiRMLEditor;
